'use strict';

require('../../company/publications/CompanyPublicationFileService.js');
require('../../company/CompanyService.js');
require('../../company/publications/CompanyPublicationWallDirective.js');
require('../../company/publications/plant/CompanyPublicationPlantService.js');

function CompanyGuestPlantDetailCtrl(
  $scope,
  publication,
  files,
  plant,
  translations,
  $stateParams,
  CompanyPublicationService,
  CompanyPublicationFileService,
  $sce,
  config,
  activityService
) {
  $scope.plant = plant;
  $scope.publication = publication;
  $scope.files = files;
  $scope.translations = translations;
  $scope.activityService = activityService;

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
      'content': '',
      'template': 'partials/company-guest/plants/detail/latest.html',
      'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

}

CompanyGuestPlantDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  plant: ['$stateParams', 'publication', 'CompanyPublicationPlantService', function($stateParams, publication, CompanyPublicationPlantService) {
    if (publication.features.currentPlantId) {
      return CompanyPublicationPlantService.get({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        plantId: publication.features.currentPlantId}).$promise;
    }
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestPlantDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPlantDetailCtrl', [
  '$scope',
  'publication',
  'files',
  'plant',
  'translations',
  '$stateParams',
  'CompanyPublicationService',
  'CompanyPublicationFileService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestPlantDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/plants/CompanyGuestPlantDetailCtrl.js
// module id = 297
// module chunks = 0